// src/RouterRoot.jsx
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { DarkModeProvider } from "./DarkModeContext";

// Pages
import LandingPage from "./pages/LandingPage";
import BuySanJuan from "./pages/BuySanJuan";
import BuySanJuanEs from "./pages/BuySanJuanEs";
import BuyMexicoCity from "./pages/BuyMexicoCity";
import BuyChicago from "./pages/BuyChicago";
import BuyChicago2 from "./pages/BuyChicago2";
import LoginPage from "./pages/LoginPage";
import SignUpForm from "./SignUpForm";
import Profile from "./pages/Profile";
import TermsOfUse from "./pages/TermsOfUse";
import TourRouter from "./pages/TourRouter";
import PurchaseSuccess from "./pages/PurchaseSuccess";
import GiftCertificate from "./pages/GiftCertificate";
import GiftLookup from "./pages/GiftLookup";

// Guards
import RequireAuth from "./components/RequireAuth";
import RequirePurchase from "./components/RequirePurchase";
import Header from "./components/Header";
import HowTo from "./pages/HowTo";


export default function RouterRoot() {
  // Hide splash screen after app mounts
  useEffect(() => {
    if (window.hideSplashScreen) {
      window.hideSplashScreen();
    }
  }, []);

  return (
    <AuthProvider>
      <DarkModeProvider>
        <BrowserRouter>
          <Routes>
          {/* Landing page */}
          <Route path="/" element={<LandingPage />} />

          {/* Buy landing pages */}
          <Route path="/buy/san-juan" element={<BuySanJuan />} />
          <Route path="/buy/san-juan-es" element={<BuySanJuanEs />} />
          <Route path="/buy/mexico-city" element={<BuyMexicoCity />} />
          <Route path="/buy/chicago" element={<BuyChicago />} />
          <Route path="/chicago-tour" element={<BuyChicago2 />} />

          {/* Purchase success page */}
          <Route path="/purchase-success" element={<PurchaseSuccess />} />

          {/* Gift certificate page */}
          <Route path="/gift-certificate" element={<GiftCertificate />} />

          {/* Gift certificate lookup page */}
          <Route path="/gift-lookup" element={<GiftLookup />} />

          {/* Login page */}
          <Route path="/login" element={<LoginPage />} />

          {/* Profile page */}
          <Route path="/profile" element={<Profile />} />

          {/* Terms of Use */}
          <Route path="/terms" element={<TermsOfUse />} />

          {/* Sign Up form */}
          <Route path="/signup" element={<SignUpForm />} />

          {/* Header */}
          <Route path="/Header" element={<Header />} />

          {/* How To */}
          <Route path="/how-to" element={<HowTo />} />

          {/* Tours - routed based on tourId */}
          <Route
            path="/tour/:tourId"
            element={
              <RequireAuth>
                <RequirePurchase>
                  <TourRouter />
                </RequirePurchase>
              </RequireAuth>
            }
          />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </DarkModeProvider>
    </AuthProvider>
  );
}
